import { sdkRequest } from '@eventbrite/http';

const getUserUrl = (id = 'me') => `/api/v3/users/${id}/`;

export const getUser = (id) => sdkRequest(getUserUrl(id));
